import React, { useState, useEffect } from "react";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@material-ui/lab";
import {
  makeStyles,
  useMediaQuery,
  useTheme,
  Popover,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import TimelineCard from "./TimelineCard";
import TimelinePopUp from "./TimelinePopUp";
import styled from "styled-components";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    width: "95%",
    maxWidth: "800px",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(1),
      width: "100%",
    },
  },
  timelineItem: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
      justifyContent: "flex-start",
    },
  },
  separator: {
    minWidth: "16px",
    [theme.breakpoints.down("sm")]: {
      minWidth: "16px",
    },
  },
  timelineDot: {
    width: 16,
    height: 16,
    marginTop: 4,
  },
  completedConnector: {
    backgroundColor: theme.palette.primary.main,
    marginTop: 0,
    marginBottom: 0,
  },
  timelineContent: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
}));

const ATLTinkerpreneurTimeline = ({ events, handleEnroll }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const handleCardClick = (event, timelineEvent) => {
    if (timelineEvent.status === "Pending") return;
    setAnchorEl(event.currentTarget);
    setSelectedEvent(timelineEvent);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedEvent(null);
  };

  const open = Boolean(anchorEl);

  const getDotColor = (event) => {
    let dotColor = "";
    switch (event.status) {
      case "Upcoming":
        dotColor = "secondary";
        break;
      case "Pending":
        dotColor = "inherit";
        break;
      default:
        dotColor = "primary";
        break;
    }
    return dotColor;
  };

  return (
    <div className={classes.container}>
      <h2 className="mar-b-30 text-center">
        {t("atl_tinkerpreneur.timeline_heading_text")}
      </h2>
      <Timeline align={isMobile ? "left" : "alternate"}>
        {events.map((item, index) => (
          <TimelineItem key={index} className={classes.timelineItem}>
            <TimelineSeparator className={classes.separator}>
              <TimelineDot
                className={classes.timelineDot}
                color={getDotColor(item)}
                variant={item.status === "Upcoming" ? "outlined" : "default"}
              />
              {index < events.length && (
                <TimelineConnector
                  className={`${classes.mobileConnector} ${
                    item.status === "Completed"
                      ? classes.completedConnector
                      : ""
                  }`}
                />
              )}
            </TimelineSeparator>

            <TimelineContent
              className={`${
                isMobile
                  ? classes.leftCard
                  : index % 2 === 0
                  ? classes.leftCard
                  : classes.rightCard
              } ${classes.timelineContent}`}
            >
              <TimelineCard
                item={item}
                onClick={(e) => handleCardClick(e, item)}
              />
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {selectedEvent && (
          <TimelinePopUp
            event={selectedEvent}
            onClose={handleClose}
            handleEnroll={handleEnroll}
          />
        )}
      </Popover>
    </div>
  );
};

export default ATLTinkerpreneurTimeline;
